export type Attrs = {
  dr: string | null;
  drIf: string | null;
  drAppender: string | null;
  drFor: string | null;
  drForOf: string | null;
  drThisProperty: string | null;
  drRepeat: string | null;
  drThis: string | null;
  drStripElement: string | null;
  drReplaceTargetElementIs: string | null;
  drForm: string | null;
  drPre: string | null;
  drInnerHTML: string | null;
  drInnerText: string | null;
  drItOption: string | null;
  drVarOption: string | null;
  drAfterOption: string | null;
  drNextOption: string | null;
  drBeforeOption: string | null;
  drCompleteOption: string | null;
  drStripOption: string | null;
  drIfOption: string | null;
  drDetectIfOption: string | null;
  drDestroyOption: string | null;
  drHasKeysOption: string | null;
  drKeyOption: string | null;
  drItemIndexOffsetOption: string | null;
  drVariableNameOption: string | null;
  drItemVariableNameOption: string | null;
  drItemIndexVariableNameOption: string | null;
  drItemOffsetIndexVariableNameOption: string | null;
};
